export default __webpack_public_path__ + "static/media/job_offer12_m.3e6b9d39.jpg";